// extracted by css-extract-rspack-plugin
export default {"projectSelectorForm":"UACCTA5MfYa3vigc","projectSelectorButton":"xYClyzrptUwFpz_e"};